import React from 'react';
import PropTypes from 'prop-types';

import ImportRequestsRow from './import_requests_row';

export default function ImportRequestsTable({ importRequests }) {
  return (
    <div className="table-responsive">
      <table className="table table-hover border-clear m-0 table-fixed">
        <thead>
          <tr>
            <th>Client</th>
            <th>Date Requested</th>
            <th>Status</th>
            <th>Memo</th>
          </tr>
        </thead>

        <tbody>
          {importRequests.map(request => (<ImportRequestsRow importRequest={request} key={request.id} />))}
        </tbody>
      </table>
    </div>
  );
}

ImportRequestsTable.propTypes = {
  importRequests: PropTypes.array
};
